import React, { FunctionComponent, useEffect, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./SubscribedPages.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { ReactComponent as LoginLogo } from "../../Assets/Images/loginlogo.svg";
import { listReExamID } from "../../Redux/Slices/ReExam/ListReExamSlice";
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SvgIcon,
  Typography,
} from "@mui/material";
import { listUserExamList } from "../../Redux/Slices/UserPackage/ListUserExamListSlice";
import { listUserPackageDetails } from "../../Redux/Slices/UserPackage/ListUserPackageDetailsSlice";
import AlarmIcon from "@mui/icons-material/Alarm";
import {
  clearListSubscription,
  listSubscription,
} from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import { Grid } from "@mui/material";
import StripeWrapper from "../../Components/Stripe/Stripe";
import StyleIcon from "@mui/icons-material/Style";
import Cardimage from "./Card.svg";
import Successimage from "./Success.jpg";
import ButtonField from "../../Components/Button/ButtonField";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import AppBarnav from "../../Components/AppBar/AppBar";
import {
  clearDashboardChart,
  dashboardChart,
} from "../../Redux/Slices/DashboardChart/DashboardChart";
import { Container, Box, Divider } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
interface SubscribedPagesProps {}

const SubscribedPages: FunctionComponent<SubscribedPagesProps> = () => {
  // Create an array of instruction objects
  const navigate = useNavigate();
  // const { state: exam_id } = useLocation();
  const dispatch = useAppDispatch();
  // const { data: listUserPackageDetailsSlice } = useAppSelector(
  //   (state) => state.ListUserPackageDetailsSlice
  // );
  // const Packagedetails: any = listUserPackageDetailsSlice?.data;
  // useEffect(() => {
  //   dispatch(listUserPackageDetails({ package_id: exam_id }));
  // }, []);

  // payment option

  const [open, setOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [discardOpen, setDiscardOpen] = useState(false);

  const handlePaymentSuccess = () => {
    setDialogMessage("Payment successful!");
    setIsSuccess(true);
    setOpen(true);
  };

  const handlePaymentError = (error: any) => {
    setDialogMessage(`Payment failed: ${error.message}`);
    setIsSuccess(false);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // ...........

  const { data: SubscriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );
  const Subcriptiondetails: any = SubscriptionSlice?.data;

  const [isStripeProcessing, setIsStripeProcessing] = useState(false);
  console.log(isStripeProcessing, "isStripeProcessing");


  useEffect(() => {
  window.history.pushState(null, "", window.location.href);

  const handleBackButton = (event: PopStateEvent) => {
    setDiscardOpen(true);

    window.history.pushState(null, "", window.location.href);
  };

  window.addEventListener("popstate", handleBackButton);

  return () => {
    window.removeEventListener("popstate", handleBackButton);
  };
}, []);


  return (
    <>
      <Grid container sx={{ width: "100%", minHeight: "100vh" }}>
        {/* Left Side - Subscription Details */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundColor: "#e0f2f7",
            padding: {
              xs: "30px 20px",
              sm: "40px 30px",
              md: "50px 60px 0px 200px",
            },
          }}
        >
          {!isStripeProcessing && (
            <ArrowBackIcon
              onClick={() => {
                setDiscardOpen(true);
              }}
            />
          )}

          <Container
            sx={{
              justifyContent: "center",
              width: "100%",
            }}
          >
            <SvgIcon
              sx={{
                width: { xs: "50%", md: "25%" },
                height: "auto",
                padding: "15px 0px",
              }}
              component={LoginLogo}
              inheritViewBox
            />

            <Typography
              variant="h6"
              sx={{
                marginBottom: "10px",
                fontWeight: 400,
                color: "text.secondary",
              }}
            >
              Subscribe to GATE AI Online Question Bank
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "20px",
              }}
            >
              <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                A$9.69
              </Typography>
              <Typography sx={{ marginLeft: "5px", fontSize: "15px" }}>
                per week
              </Typography>
            </Box>

            <Divider sx={{ marginBottom: "20px" }} />

            {/* Item Details */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Box>
                <Typography sx={{ fontWeight: "medium", fontSize: "13px" }}>
                  GATE AI Online Question Bank
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  https://learn.everesttutoring.com.au/
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Billed monthly ( $9.69per week, roughly 4.33 weeks in a month
                  which equates to ~$42/month.)
                </Typography>
              </Box>
              <Typography sx={{ fontWeight: "medium", fontSize: "15px" }}>
                A$42
              </Typography>
            </Box>

            <Divider sx={{ marginY: "20px" }} />

            {/* Subtotal */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Typography sx={{ fontWeight: "medium", fontSize: "13px" }}>
                Subtotal
              </Typography>
              <Typography sx={{ fontWeight: "medium", fontSize: "15px" }}>
                A$42
              </Typography>
            </Box>

            <Divider sx={{ marginY: "20px" }} />

            {/* Total Due */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: "medium", fontSize: "13px" }}>
                Total due today
              </Typography>
              <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                A$42
              </Typography>
            </Box>
          </Container>
        </Grid>

        {/* Right Side - Payment Form */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            padding: {
              xs: "30px 20px",
              sm: "40px 30px",
              md: "50px 150px 0px 70px",
            },
          }}
        >
          <StripeWrapper
            paymentCurrency="usd"
            onPaymentSuccess={handlePaymentSuccess}
            onPaymentError={handlePaymentError}
            // onLoadingChange={handleLoadingChange}
            onProcessingChange={setIsStripeProcessing} // 👈 NEW
          />
        </Grid>
      </Grid>
      <React.Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {isSuccess === true && (
              <img src={Successimage} alt={`sd`} style={{ width: "300px" }} />
            )}
            {isSuccess === false && (
              <ReportGmailerrorredIcon
                sx={{ fontSize: "50px", color: "red" }}
              />
            )}

            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {isSuccess ? "Success" : "Error"}
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px", textAlign: "center" }}
            >
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                dispatch(clearDashboardChart());
                setOpen(false);
                navigate("/dashboard");
                dispatch(clearListSubscription());
              }}
            >
              Ok
            </ButtonField>
          </DialogActions>
        </Dialog>
        <Dialog open={discardOpen} onClose={() => setDiscardOpen(false)}>
          <DialogTitle
            sx={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}
          >
            Are you sure?
          </DialogTitle>

          <DialogContent>
            <DialogContentText sx={{ textAlign: "center", fontSize: "14px" }}>
              Do you really want to discard subscription process?
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <ButtonField
              onClick={() => setDiscardOpen(false)}
              className="form_cancel_button"
            >
              No
            </ButtonField>

            <ButtonField
              onClick={() => {
                setDiscardOpen(false);
                dispatch(clearListSubscription());
                dispatch(clearDashboardChart());
                navigate("/totalexam"); //
              }}
              className="form_save_button"
            >
              Yes, Discard
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default SubscribedPages;
